module.exports = __webpack_public_path__ + "static/media/hello_preview.12304670.png";